import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UnitDetailsComponent } from '../unit-details/unit-details.component';
import { UnitsService } from 'src/app/services/units.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-invtaion',
  templateUrl: './invtaion.component.html',
  styleUrls: ['./invtaion.component.css']
})
export class InvtaionComponent implements OnInit {

  invite: FormGroup | any;
  qrtypes_arr:any = []
  unitName :any = ''
  clientName : any = ''
  typeID:any
  Choose_QR_Type = "Choose QR Type"
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<UnitDetailsComponent>,
  private rest : UnitsService){}

  ngOnInit(){
    this.unitName = this.data.unitName
    this.clientName = this.data.clientName
    console.log(this.data)
    this.retiveInvtaion()
    this.getQrType()
    this.initForm()
  }

  initForm(){
    this.invite = new FormGroup({
      customer_name: new FormControl("", [Validators.required]),
      phone_number: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.required]),
      valid_from: new FormControl("", [Validators.required]),
      valid_to: new FormControl("", [Validators.required]),
      count: new FormControl("", [Validators.required]),
    })
  }




  getQrType(){
    this.rest.qrtypes().subscribe((res:any) => {
      console.log(res)
      this.qrtypes_arr = res.children
    })
  }


  getType(value:any){
    this.Choose_QR_Type = value.name
    this.typeID = value.id
  }

  genrateInvitation(value:any){

    let data = this.invite.value
    data.type_id = this.typeID
    this.dialogRef.close({data,'value' :value});
  }

  retiveInvtaion(){
    this.rest.retriveInvtaion(this.data.unitId).subscribe((res:any) => {
      console.log(res)
    })
  }
}
